import { EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  getTravelingTypeApi,
  insertTravelingTypeApi,
  updateTravelingTypeApi
} from "src/api/commonapi";
import CustomLoader from "src/commonComponents/CustomLoader";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";

export default function TravelingPurpose() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [travellingPurposeData, setTravelingPurposeData] = useState({
    type: ""
  });
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const resetFormData = () => {
    setTravelingPurposeData({
      type: ""
    });
  };

  const handleGetTravelingPurposeData = async () => {
    setIsLoading(true);
    let res = await getTravelingTypeApi();
    setIsLoading(false);
    setTableData(res?.data);
  };

  const handleSubmit = async () => {
    if (travellingPurposeData.type !== "") {
      if (travellingPurposeData.t_t_id !== undefined) {
        // Update
        setIsLoading(true);
        let resp = await updateTravelingTypeApi(travellingPurposeData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          handleGetTravelingPurposeData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        // Insert
        setIsLoading(true);
        let resp = await insertTravelingTypeApi(travellingPurposeData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          handleGetTravelingPurposeData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      }
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  useEffect(() => {
    handleGetTravelingPurposeData();
  }, []);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.t_t_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Traveling Purpose",
      wrap: true,
      selector: (row) => row?.type,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                setTravelingPurposeData({
                  type: row.type,
                  t_t_id: row.t_t_id
                });
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <Page title="LVB Traveling Purpose | Local Vocal Business Group">
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Traveling Purpose
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => (toggleAddEditModal(), resetFormData())}
              style={{ marginBottom: "15px", float: "right" }}
              variant="contained"
            >
              Add Traveling Purpose
            </Button>
          </Grid>
        </Grid>
        <Modal
          open={addEditModal}
          onClose={() => (toggleAddEditModal(), resetFormData())}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: "5px", textAlign: "center" }}
            >
              Add Traveling Purpose
            </Typography>
            <hr />
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <Grid container>
                <Grid item sm={12} xs={12}>
                  <TextField
                    style={{ marginTop: "15px" }}
                    height={10}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Traveling Purpose"
                    name="type"
                    placeholder="Enter Traveling Purpose"
                    onChange={(e) => {
                      setTravelingPurposeData({
                        ...travellingPurposeData,
                        type: e.target.value
                      });
                    }}
                    value={travellingPurposeData?.type}
                  />
                </Grid>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => (toggleAddEditModal(), resetFormData())}
                    style={{ marginTop: "15px", marginRight: "15px" }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    style={{ marginTop: "15px" }}
                    onClick={() => handleSubmit()}
                    disabled={isLoading}
                    startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </Modal>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            filter
            pagination
            highlightOnHover
            columns={columns}
            data={tableData != null ? tableData : []}
            progressPending={isLoading}
            progressComponent={<CustomLoader />}
          />
        </Card>
      </Container>
    </Page>
  );
}
